import { Checkbox, styled } from '@mui/material';

 const CustomBlueCheckbox = styled(Checkbox)(({ theme }) => ({
    '&.Mui-checked': {
        color: '#0F2B63', // Checkmark color
    },
    '&.Mui-checked + .MuiIconButton-label:before': {
        backgroundColor: '#0F2B63', // Background color for checked state
    },
}));

export default CustomBlueCheckbox

